export enum OrderSourceValues {
  NATIVE = 'native',
  KIOSK = 'kiosk',
  GENERIC_MARKETPLACE = 'marketplace',
  UBER_EATS_MARKETPLACE = 'ue_marketplace',
  DOORDASH_MARKETPLACE = 'dd_marketplace',
  GRUBHUB_MARKETPLACE = 'gh_marketplace',
  SHAREBITE_MARKETPLACE = 'sb_marketplace',
  MEALPAL_MARKETPLACE = 'mp_marketplace',
  FOODA_MARKETPLACE = 'fa_marketplace',
  EZCATER_MARKETPLACE = 'ezc_marketplace',
  EZCATER_B2B_MARKETPLACE = 'ezcb2b_marketplace',
  EZ_ORDERING = 'ez_ordering',
}

/**
 * Mirror of `Gravy::OrderSource::B2C_MARKETPLACES`: the consumer marketplaces
 * that list standalone stores. Per gravy's definition, the remaining
 * marketplaces "act as outposts and are b2b" — a different channel with
 * parent-managed enablement. Keep in sync with
 * apps/gravy/lib/gravy/core/app/constants/gravy/order_source.rb.
 */
export const B2C_MARKETPLACES = [
  OrderSourceValues.UBER_EATS_MARKETPLACE,
  OrderSourceValues.DOORDASH_MARKETPLACE,
  OrderSourceValues.GRUBHUB_MARKETPLACE,
] as const;

export type B2cMarketplace = (typeof B2C_MARKETPLACES)[number];

/** Type-narrowing mirror of gravy's `OrderSource.b2c_marketplace?`. */
export const isB2cMarketplace = (
  source: OrderSourceValues | string | null | undefined,
): source is B2cMarketplace => B2C_MARKETPLACES.includes(source as B2cMarketplace);
